import { PayoutEntryHedge } from '../../../state/Radom'

export const toCostNumber = (value: number | string | undefined): number => {
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) ? n : 0
}

export interface HedgedPayoutCostParts {
  guaranteedAmount: number
  lockedRate: number
  radomFee: number
  networkFee: number
  stablecoinCost: number
}

export const computeHedgedPayoutCosts = (
  hedge: PayoutEntryHedge,
  recipientAmount?: number | string
): HedgedPayoutCostParts => {
  const guaranteedAmount = toCostNumber(recipientAmount ?? hedge.guaranteedAmount)
  const lockedRate = toCostNumber(hedge.lockedRate)
  const radomFee = toCostNumber(hedge.conversionFee)
  const stableForTrade = toCostNumber(hedge.stableForTrade)
  const stablecoinCost = toCostNumber(hedge.stablecoinCost)
  const conversionAtRate = guaranteedAmount * lockedRate
  const networkFee = Math.max(0, stableForTrade - conversionAtRate)

  return {
    guaranteedAmount,
    lockedRate,
    radomFee,
    networkFee,
    stablecoinCost
  }
}
